import React, { useState, useEffect } from 'react';
import { FormControl, TextField } from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import api from '../services/api';

// Seletor de túnel standalone: lista os túneis cadastrados (/hermes/host/tunnel/all)
// e permite escolher "Direto (sem túnel)". O valor é o id do túnel (ou null).
export default function TunnelSelect({ handler = () => {}, value, disabled = false, size = 'small' }) {
  const [options, setOptions] = useState([]);

  useEffect(() => {
    api.get('/hermes/host/tunnel/all')
      .then((res) => setOptions(res.data || []))
      .catch(() => setOptions([]));
  }, []);

  const DIRECT = { id: null, name: 'Direto (sem túnel)' };
  const all = [DIRECT, ...options];
  const selected = all.find((o) => o.id === value) || DIRECT;

  return (
    <FormControl fullWidth margin="dense">
      <Autocomplete
        size={size}
        disabled={disabled}
        options={all}
        value={selected}
        isOptionEqualToValue={(o, v) => o.id === v.id}
        getOptionLabel={(o) => o.name || ''}
        onChange={(_, val) => handler(val ? val.id : null)}
        renderInput={(params) => <TextField {...params} label="Conectividade / Túnel" />}
      />
    </FormControl>
  );
}
